import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import AdsPage from './pages/AdsPage';
import AdDetailPage from './pages/AdDetailPage';
import CreateAdPage from './pages/CreateAdPage';
import CategoriesPage from './pages/CategoriesPage';
import CategoryAdsPage from './pages/CategoryAdsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import UserProfilePage from './pages/UserProfilePage';
import ServicesPage from './pages/ServicesPage';
import MyProfilePage from './pages/MyProfilePage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 3000,
              style: {
                fontFamily: 'Cairo',
                direction: 'rtl',
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="ads" element={<AdsPage />} />
              <Route path="ads/create" element={<CreateAdPage />} />
              <Route path="ads/:id" element={<AdDetailPage />} />
              <Route path="categories" element={<CategoriesPage />} />
              <Route path="categories/:slug" element={<CategoryAdsPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="register" element={<RegisterPage />} />
              <Route path="users/:id" element={<UserProfilePage />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="my/profile" element={<MyProfilePage />} />
              <Route path="my/favorites" element={<LoginPage />} />
              <Route path="my/conversations" element={<LoginPage />} />
              <Route path="my/notifications" element={<LoginPage />} />
              <Route path="my/ads" element={<LoginPage />} />
              <Route path="search" element={<AdsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
